// @ts-nocheck
/* eslint-disable */
import {
	InfoCircleOutlined,
	CheckCircleFilled,
	CloseCircleFilled,
	LoadingOutlined,
} from '@ant-design/icons';
import { Button, Col, Dropdown, Menu, Modal, Row, Spin, Tooltip } from 'antd';
import message from '../utils/messageWithScroll';
import { LanguageContext } from 'contexts/LanguageContext';
import { SystemContext } from 'contexts/legacy/SystemContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import React, { useContext, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import LinkChannelView from 'views/MainPage/LinkChannel/';
import AddNumberView from 'views/MainPage/Numbers/AddEditNumberView';

const { confirm } = Modal;

/**
 * @param {Object} props
 * @param {Object} props.numberInfo
 * @param {string} props.numberType
 * @param {Object} props.bitrix24
 * @param {Object} props.number
 */
function NumberItem({ numberInfo, numberType, bitrix24, number }) {
	const { dictionary } = useContext(LanguageContext);
	const { subscription } = useContext(SystemContext);
	const [isVisible, setIsVisible] = useState(false);
	const [isLinkVisible, setIsLinkVisible] = useState(false);
	const [validity, setValidity] = useState(0);

	const proNumber = numberType === 'pro';

	function handleShowEdit() {
		window.scrollTo(0, 0);
		setIsVisible(true);
	}

	function handleCancelEdit() {
		window.scrollTo(0, 0);
		setIsVisible(false);
	}

	function handleOkEdit() {
		setIsVisible(false);
	}

	function handleShowLinkChannel() {
		window.scrollTo(0, 0);
		setIsLinkVisible(true);
	}

	function handleCancelLinkChannel() {
		window.scrollTo(0, 0);
		setIsLinkVisible(false);
	}

	function handleConfirmUnlinkChannel() {
		const { unlinkChannel } = bitrix24;
		const { getConnectedChannels, getListOfNumbers, getListCampaigns } = number;

		confirm({
			title:
				dictionary.unlink_channel_msg + " '" + numberInfo.name + ' (' + numberInfo.number + ")'?",
			okText: dictionary.yes,
			okType: 'danger',
			cancelText: dictionary.not,
			async onOk() {
				await unlinkChannel(numberInfo.id, numberInfo.id_channel)
					.then(() => {
						message.success(dictionary.unlink_channel_success);
						getConnectedChannels();
						getListOfNumbers();
						getListCampaigns();
					})
					.catch((err) => {
						if (err.message) {
							message.error(err.message);
						} else {
							message.error(dictionary.unlink_channel_error);
						}
					});
			},
			onCancel() {},
		});
	}

	async function handleClearQueue() {
		const { clearQueue, messagesOnQueue } = number;

		const numberOfMessages = await messagesOnQueue(numberInfo.token);

		confirm({
			title: dictionary.clear_queue_msg,
			content: dictionary.number_of_messages_on_queue + numberOfMessages,
			okText: dictionary.yes,
			okType: 'danger',
			cancelText: dictionary.not,
			async onOk() {
				const result = await clearQueue(numberInfo.token);
				if (result) {
					message.success(dictionary.clear_queue_success);
				} else {
					message.error(dictionary.clear_queue_error);
				}
			},
		});
	}

	async function handleConfirmDelete() {
		const { deleteNumber, getListOfNumbers, getConnectedChannels, getListCampaigns } = number;

		await number.getListCampaigns();

		const numberCampaign = number.campaigns.filter((campaign) => campaign.id === numberInfo.id);

		const hasCampaign = numberCampaign.length > 0;

		confirm({
			title: dictionary.delete_msg + " '" + numberInfo.name + ' (' + numberInfo.number + ")'?",
			content: hasCampaign ? dictionary.delete_campaign_warning : '',
			okText: dictionary.yes,
			okType: 'danger',
			cancelText: dictionary.not,
			async onOk() {
				await deleteNumber(numberInfo.id, numberInfo.number)
					.then(() => {
						message.success(dictionary.delete_number_success);
						getListOfNumbers();
						getConnectedChannels();
						getListCampaigns();
					})
					.catch((err) => {
						if (err.message) {
							message.error(err.message);
						} else {
							message.error(dictionary.delete_number_error);
						}
					});
			},
		});
	}

	useEffect(() => {
		if (proNumber && numberInfo && subscription.billing_period) {
			const trialValidity = new Date(numberInfo.containerInfo.info.due);
			const endAt = new Date(subscription.end_at);
			if (endAt <= trialValidity && subscription.billing_period === 'trial') {
				const validity = endAt.toLocaleString();
				setValidity(validity);
			} else {
				const validity = trialValidity.toLocaleString();
				setValidity(validity);
			}
		}
	}, [proNumber, numberInfo, subscription, validity]);

	return (
		<div style={{ backgroundColor: '#e8f9fe', padding: 12 }}>
			<Row>
				<Col
					span={proNumber ? 6 : 9}
					style={{
						lineHeight: '32px',
						fontWeight: 'bold',
					}}
				>
					{numberInfo.name ? numberInfo.name : '-'}
				</Col>
				<Col span={5} style={{ lineHeight: '32px' }}>
					{numberInfo.number ? numberInfo.number : ''}
				</Col>
				<Col span={4} style={{ lineHeight: '32px' }}>
					{proNumber ? (
						<>
							{number.loadingNumbersStatus ? (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										height: '32px',
										marginLeft: '-40px',
									}}
								>
									<Spin
										indicator={<LoadingOutlined style={{ fontSize: 16, color: '#1890ff' }} spin />}
									/>
								</div>
							) : (
								<>{dictionary[numberInfo.containerInfo.info.paymentStatus]}</>
							)}
						</>
					) : (
						<>
							{numberInfo.api_name
								? numberInfo.api_name.charAt(0).toUpperCase() + numberInfo.api_name.slice(1)
								: ''}
						</>
					)}
					{proNumber && numberInfo.containerInfo.info.paymentStatus === 'TRIAL' && (
						<>
							<Tooltip
								placement="right"
								className="ml-2"
								title={
									<FormattedMessage
										id="validity_trial"
										values={{
											validity,
										}}
									/>
								}
							>
								<InfoCircleOutlined style={{ fontSize: '16px', color: '#08c' }} />
							</Tooltip>
						</>
					)}
				</Col>

				{proNumber && (
					<Col span={3} style={{ lineHeight: '32px', textAlign: 'center' }}>
						{number.loadingNumbersStatus ? (
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									height: '32px',
								}}
							>
								<Spin
									indicator={<LoadingOutlined style={{ fontSize: 16, color: '#1890ff' }} spin />}
								/>
							</div>
						) : (
							<>
								{numberInfo.sessionInfo.status ? (
									<CheckCircleFilled style={{ color: '#52c41a', fontSize: '18px' }} />
								) : (
									<CloseCircleFilled style={{ color: '#ff4d4f', fontSize: '18px' }} />
								)}
							</>
						)}
					</Col>
				)}

				<Col span={4} style={{ lineHeight: '32px', textAlign: 'center' }}>
					{numberInfo.audio_transcription === '1' || numberInfo.audio_transcription === 1 ? (
						<CheckCircleFilled style={{ color: '#52c41a', fontSize: '18px' }} />
					) : (
						<CloseCircleFilled style={{ color: '#ff4d4f', fontSize: '18px' }} />
					)}
				</Col>

				<Col span={proNumber ? 2 : 2}>
					<Dropdown
						overlay={
							<Menu>
								<Menu.Item>
									<Button
										onClick={handleShowEdit}
										type="link"
										style={{
											color: '#000',
											height: 'auto',
											width: '100%',
											textAlign: 'left',
										}}
									>
										<FormattedMessage id="edit" />
									</Button>
								</Menu.Item>
								{numberInfo.id_channel === '' || !numberInfo.id_channel ? (
									<Menu.Item>
										<Button
											onClick={handleShowLinkChannel}
											type="link"
											style={{
												color: '#000',
												height: 'auto',
												width: '100%',
												textAlign: 'left',
											}}
										>
											<FormattedMessage id="link_channel" />
										</Button>
									</Menu.Item>
								) : (
									<Menu.Item>
										<Button
											onClick={handleConfirmUnlinkChannel}
											type="link"
											style={{
												color: '#000',
												height: 'auto',
												width: '100%',
												textAlign: 'left',
											}}
										>
											<FormattedMessage id="unlink_channel" />
										</Button>
									</Menu.Item>
								)}
								{numberInfo.api === 'zapi' && (
									<Menu.Item>
										<Button
											onClick={handleClearQueue}
											type="link"
											style={{
												color: '#000',
												height: 'auto',
												width: '100%',
												textAlign: 'left',
											}}
										>
											<FormattedMessage id="clear_queue" />
										</Button>
									</Menu.Item>
								)}
								<Menu.Item style={{ background: '#ffe5e5' }}>
									<Button
										onClick={handleConfirmDelete}
										type="link"
										style={{
											color: '#000',
											height: 'auto',
											width: '100%',
											textAlign: 'left',
										}}
									>
										<FormattedMessage id="delete" />
									</Button>
								</Menu.Item>
							</Menu>
						}
						placement="bottomRight"
					>
						<Button style={{ float: 'right' }} icon="menu" />
					</Dropdown>
				</Col>
			</Row>
			<AddNumberView
				visible={isVisible}
				title={<FormattedMessage id="edit_numbers_title" values={{ number: numberInfo.number }} />}
				cancelAction={handleCancelEdit}
				okAction={handleOkEdit}
				formNumber={numberInfo}
			/>
			<LinkChannelView
				visible={isLinkVisible}
				numberForm={numberInfo}
				cancelAction={handleCancelLinkChannel}
			/>
		</div>
	);
}

export default Bitrix24Consumer(NumberConsumer(NumberItem));
